'use client';
import React, { use, useEffect } from 'react';

import Input_Primary from '../Input_Primary/Input_Primary';
import { useUser } from '@/store';
import { ValidateField } from '@/features/Onboarding/components/Steps/VerificationLevel1/VerificationLevel1';

// setFirstName;

interface Input_FirstNameProps {
	firstName: string;
	setFirstName: (firstName: string) => void;
	validateField: ValidateField;
}
const Input_FirstName = ({
	firstName,
	setFirstName,
	validateField,
}: Input_FirstNameProps) => {
	const user = useUser();

	useEffect(() => {
		if (user?.firstName) {
			setFirstName(user.firstName);
		}
	}, [user]);

	return (
		<div className="flex flex-col gap-4 w-full relative justify-center">
			<label htmlFor="firstName" className="text-sm font-bold">
				What is your name?
			</label>
			<Input_Primary
				inputProps={{
					id: 'firstName',
					type: 'text',
					name: 'firstName',
					placeholder: 'First Name',
					defaultValue: firstName || '',
					value: firstName || '',
					onChange: (e) => {
						setFirstName(e.target.value);
					},
					onBlur: (e) => {
						if (validateField) {
							validateField('firstName');
						}
					},
				}}
				// error={true}
				// label="First Name*"
				labelProps={{
					htmlFor: 'firstName',
				}}
			/>
		</div>
	);
};

export default Input_FirstName;
